enum StoreName {
    CAPTIONS        = 'captions',
    CONFIG          = 'config',
    FRAME           = 'frame',
    MEDIA           = 'media',
    LOCAL_STORAGE   = 'localStorage',
    PLAYBACK        = 'playback',
    TIMELINE        = 'timeline',
    VOLUME          = 'volume'
}

export default StoreName;